/**
 * The "Alerts" card — whatever `postNotice` last posted (`notices.ts`), dismissible, or
 * nothing at all when there isn't one. No props: like `BlackjackPage`/`DisplayCard`, it
 * needs nothing from whatever page it lands on.
 *
 * Renders `LayoutGrid`'s own `Placeholder` while unlocked and there's nothing to show —
 * `renderSection` already produced a real `<NoticeCard/>` element the instant "notice" is
 * registered, whether or not there's an actual notice, so `LayoutGrid`'s "absent" fallback
 * never sees a gap to fill for this one. Only this component knows which case it's in.
 */

import { useEditMode } from "../layout/editModeContext";
import { Placeholder } from "../layout/LayoutGrid";
import { dismissNotice, useNotice } from "../notices";

export function NoticeCard() {
  const notice = useNotice();
  const { editing } = useEditMode();
  if (!notice) return editing ? <Placeholder id="notice" /> : null;

  return (
    <div className="panel">
      <div className="row spread">
        <span className="small">{notice}</span>
        <button className="btn ghost small" onClick={dismissNotice}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
